module.exports = __webpack_public_path__ + "img/run_statistics.79963793.png";